import { UserFilter } from '@/services/users/user-filters';
import { SortingState } from '@tanstack/react-table';

export type FilterAction =
  | { type: 'SET_FILTERS'; payload: UserFilter }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'SET_PAGINATION'; payload: { skip: number; take: number } }
  | { type: 'SET_SORTING'; payload: SortingState }
  | { type: 'RESET_FILTERS' };

export interface QueryState {
  filter: UserFilter;
  skip: number;
  take: number;
  sorting: SortingState;
}

export const initialFilters: QueryState = {
  filter: {
    search: undefined,
    alias: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    isAgent: undefined,
    isAmbassador: undefined,
  },
  skip: 0,
  take: 25,
  sorting: [],
};

export const initialState: QueryState = {
  filter: initialFilters.filter,
  skip: 0,
  take: 25,
  sorting: [],
};

export const queryReducer = (state: QueryState, action: FilterAction): QueryState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return {
        ...state,
        filter: action.payload,
        skip: 0,
      };
    case 'SET_SEARCH':
      return {
        ...state,
        filter: { ...state.filter, search: action.payload },
        skip: 0,
      };
    case 'SET_PAGINATION':
      return {
        ...state,
        skip: action.payload.skip,
        take: action.payload.take,
      };
    case 'SET_SORTING':
      return {
        ...state,
        sorting: action.payload,
        skip: 0,
      };
    case 'RESET_FILTERS':
      return initialState;
    default:
      return state;
  }
};
